import { render } from "./MyOrderLegsDetail.vue?vue&type=template&id=ea8ff206"
import script from "./MyOrderLegsDetail.vue?vue&type=script&lang=js"
export * from "./MyOrderLegsDetail.vue?vue&type=script&lang=js"

import "./MyOrderLegsDetail.vue?vue&type=style&index=0&id=ea8ff206&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__